import styled from "styled-components";

import { WrapperButton } from "@ryde/controls";
import { DATA_E2E_KEY, type IStyledAttributes } from "@ryde/shared";
import { blueMui, rydeColors } from "@ryde/theme";

export const ProduceButtonsPanelTopWrapper = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "produce-buttons-panel-top-wrapper",
  },
)`
  margin-bottom: 0;
  background-color: ${rydeColors.white};
  display: flex;
  align-items: center;
  gap: 10px;
  height: 30px;
`;

export const CustomProductionToggleButtonStyled = styled(
  WrapperButton,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "custom-production-toggle-button",
})`
  color: ${blueMui.A200};
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ProduceButtonsPanelTopItemsWrapper = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "produce-buttons-panel-top-items-wrapper",
  },
)`
  padding-inline-start: 10px;
  padding-inline-end: 10px;
  display: flex;
  align-items: center;
`;
